export default {
  blocks: [
    {
      key: 'ap77n',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'es22d',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 0,
        },
      ],
      data: {},
    },
    {
      key: 'd7jvp',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {
    '0': {
      type: 'wix-draft-plugin-video',
      mutability: 'IMMUTABLE',
      data: {
        config: {
          size: 'content',
          alignment: 'center',
        },
        src: {
          pathname: 'video/11062b_a552731f40854d16a91627687fb8d1a6/1080p/mp4/file.mp4',
          thumbnail: {
            pathname: 'media/11062b_a552731f40854d16a91627687fb8d1a6f000.jpg',
            height: 1080,
            width: 1920,
          },
        },
        isCustomVideo: true,
      },
    },
  },
  VERSION: '8.24.1',
};
